module.exports = __webpack_public_path__ + "static/media/Shop-By-Tire-Brand-White.6397fe28.svg";